module.exports = __webpack_public_path__ + "static/media/dots.fc2960f7.svg";